// Small SVG donut chart for two-slice breakdowns (CIP vs O&P).
// No chart library — hand-rolled for zero deps and full styling control.
export default function CipOpDonut({ cip = 0, op = 0, size = 120, label = "reqs", testid = "cip-op-donut" }) {
  const total = cip + op;
  const stroke = 18;                              // ring thickness
  const r = (size - stroke) / 2;                  // ring radius
  const cx = size / 2, cy = size / 2;
  const circumference = 2 * Math.PI * r;
  const cipFrac = total > 0 ? cip / total : 0;
  const opFrac = total > 0 ? op / total : 0;
  const cipLen = circumference * cipFrac;
  const opLen = circumference * opFrac;

  // CIP color: royal blue; O&P color: amber
  const CIP_COLOR = "#3B82F6";
  const OP_COLOR = "#F59E0B";
  const EMPTY_COLOR = "#E2E8F0";

  return (
    <div className="flex items-center gap-3" data-testid={testid}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="shrink-0">
        {/* base ring */}
        <circle cx={cx} cy={cy} r={r} fill="none" stroke={EMPTY_COLOR} strokeWidth={stroke} />
        {total > 0 && (
          <>
            {/* CIP slice — starts at 12 o'clock, sweeps clockwise */}
            <circle
              cx={cx} cy={cy} r={r} fill="none" stroke={CIP_COLOR} strokeWidth={stroke}
              strokeDasharray={`${cipLen} ${circumference - cipLen}`}
              strokeDashoffset={0}
              transform={`rotate(-90 ${cx} ${cy})`}
              strokeLinecap="butt"
            />
            {/* O&P slice — starts where CIP ended */}
            <circle
              cx={cx} cy={cy} r={r} fill="none" stroke={OP_COLOR} strokeWidth={stroke}
              strokeDasharray={`${opLen} ${circumference - opLen}`}
              strokeDashoffset={-cipLen}
              transform={`rotate(-90 ${cx} ${cy})`}
              strokeLinecap="butt"
            />
          </>
        )}
        {/* center label */}
        <text x={cx} y={cy - 4} textAnchor="middle" className="fill-current font-bold" style={{ fontSize: 22 }}>
          {total}
        </text>
        <text x={cx} y={cy + 14} textAnchor="middle" className="fill-current opacity-60 uppercase tracking-wide" style={{ fontSize: 9, fontWeight: 700 }}>
          {label}
        </text>
      </svg>
      <div className="text-xs space-y-1.5">
        <div className="flex items-center gap-2" data-testid={`${testid}-cip`}>
          <span className="inline-block w-3 h-3 rounded-sm" style={{ background: CIP_COLOR }} />
          <span className="font-semibold">CIP</span>
          <span className="tabular-nums font-mono">{cip}</span>
          {total > 0 && <span className="text-muted-foreground">({Math.round(cipFrac * 100)}%)</span>}
        </div>
        <div className="flex items-center gap-2" data-testid={`${testid}-op`}>
          <span className="inline-block w-3 h-3 rounded-sm" style={{ background: OP_COLOR }} />
          <span className="font-semibold">O&amp;P</span>
          <span className="tabular-nums font-mono">{op}</span>
          {total > 0 && <span className="text-muted-foreground">({Math.round(opFrac * 100)}%)</span>}
        </div>
      </div>
    </div>
  );
}
